import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'; // Import the CSS for the navbar

const Navbar: React.FC = () => {
    const location = useLocation(); // Get the current location object

    // Function to generate breadcrumbs based on the current path
    const generateBreadcrumbs = () => {
        const pathnames = location.pathname.split('/').filter((x) => x);
        const breadcrumbs = [];
        const locationState = location.state as { breadcrumbTitle?: string } | null;
        const historyState = window.history.state as { breadcrumbTitle?: string } | null;

        // Always start with 'Home'
        breadcrumbs.push(
            <Link 
                key="home" 
                to="/home" 
                className="breadcrumb-link"
                onClick={() => {
                    // Scroll to top when navigating to home
                    window.scrollTo(0, 0);
                }}
            >
                Home
            </Link>
        );

        // Special handling for asset-details pages
        if (pathnames[0] === 'asset-details') {
            // Add Summary breadcrumb
            breadcrumbs.push(
                <Link 
                    key="asset" 
                    to="/home" 
                    className="breadcrumb-link"
                    onClick={() => {
                        // Scroll to top when navigating
                        window.scrollTo(0, 0);
                    }}
                >
                </Link>
            );

            // Add asset name if available
            const assetName = locationState?.breadcrumbTitle || historyState?.breadcrumbTitle;
            if (assetName) {
                breadcrumbs.push(<span key="separator-asset" className="breadcrumb-separator"> / </span>);
                breadcrumbs.push(<span key="asset-name" className="breadcrumb-current">{assetName}</span>);
            }
        } 
        // Special handling for create-plant pages
        else if (pathnames[0] === 'create-plant' || (pathnames.length === 1 && pathnames[0] === 'create-plant')) {
            // Add Plant breadcrumb
            breadcrumbs.push(<span key="separator-plant" className="breadcrumb-separator"> / </span>);
            breadcrumbs.push(
                <Link 
                    key="plant" 
                    to="/plants" 
                    className="breadcrumb-link"
                    onClick={() => {
                        // Scroll to top when navigating
                        window.scrollTo(0, 0);
                    }}
                >
                    Plant
                </Link>
            );

            // Add plant name if available (for edit mode)
            const plantName = locationState?.breadcrumbTitle || historyState?.breadcrumbTitle;
            if (plantName) {
                breadcrumbs.push(<span key="separator-plant-name" className="breadcrumb-separator"> / </span>);
                breadcrumbs.push(<span key="plant-name" className="breadcrumb-current">{plantName}</span>);
            } else {
                // For create mode, show "Create Plant"
                breadcrumbs.push(<span key="separator-create" className="breadcrumb-separator"> / </span>);
                breadcrumbs.push(<span key="create-plant" className="breadcrumb-current">Create Plant</span>);
            }
        } else {
            // Default breadcrumb generation for other pages
            pathnames.forEach((name, index) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;

                // Optional: You might want to map route names to more user-friendly titles
                let displayName = name.replace(/-/g, ' '); // Replace hyphens with spaces
                displayName = displayName.charAt(0).toUpperCase() + displayName.slice(1); // Capitalize first letter

                breadcrumbs.push(<span key={`separator-${name}`} className="breadcrumb-separator"> / </span>);

                if (isLast) {
                    // Last item is not a link, just text
                    breadcrumbs.push(<span key={name} className="breadcrumb-current">{displayName}</span>);
                } else {
                    // Intermediate items are links
                    breadcrumbs.push(
                        <Link 
                            key={name} 
                            to={routeTo} 
                            className="breadcrumb-link"
                            onClick={() => {
                                // Scroll to top when navigating
                                window.scrollTo(0, 0);
                            }}
                        >
                            {displayName}
                        </Link>
                    );
                }
            });
        }

        return breadcrumbs;
    };

    return (
        <div className="navbar-container">
            <div className="breadcrumbs">
                {generateBreadcrumbs()}
            </div>
            {/* You can add user info, notifications, or other elements here if needed */}
        </div>
    );
};

export default Navbar;